import { Button, Typography } from '@mui/material';
import { Trans } from 'react-i18next';

import { useAppSelector } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { selectUserAccountTypes } from '@/redux/user-data/selectors';

import { Tenant } from '@/types/common';

import { getStampDuty } from '@/utils/user';

import {
  ApprovedDrawerContainer,
  ApprovedImg,
  StyledApprovedDrawer,
} from './Drawers.styled';

type ApprovedDrawerProps = {
  onClose: () => void;
  tenant?: Tenant;
};

export function ApprovedDrawer({
  onClose,
  tenant,
}: Readonly<ApprovedDrawerProps>) {
  const { t } = useTranslate();
  const accountTypes = useAppSelector(selectUserAccountTypes);
  const additionalInfo =
    accountTypes.find(type => type.additionalInfo)?.additionalInfo || '';
  const stampDuty = getStampDuty(additionalInfo);

  return (
    <StyledApprovedDrawer open anchor="bottom" hideBackdrop={false}>
      <ApprovedDrawerContainer>
        <ApprovedImg />
        <Typography
          variant="h3"
          textAlign="center"
          mb={tenant === Tenant.Cayman ? 4 : 1}
        >
          {t('moreInfo.approvedDrawer.title')}
        </Typography>

        {tenant !== Tenant.Cayman && (
          <Typography variant="body2" textAlign="center" mb={3}>
            {t('moreInfo.approvedDrawer.body')}
            {stampDuty && (
              <Typography variant="body2" textAlign="center" mt={1}>
                <Trans
                  i18nKey="moreInfo.approvedDrawer.reminder"
                  components={{
                    b: <b />,
                  }}
                  values={{ stampDuty }}
                />
              </Typography>
            )}
          </Typography>
        )}

        <Button onClick={onClose} fullWidth>
          {t('moreInfo.approvedDrawer.button.dismiss')}
        </Button>
      </ApprovedDrawerContainer>
    </StyledApprovedDrawer>
  );
}
